import React, { useState, useEffect } from 'react';
import useScreenSize from 'js/utils/hooks/useScreenSize';
import useResizeObserver from '@react-hook/resize-observer';
import ImpressionWatcher, {
  Props as ImpressionProps,
} from 'js/utils/impressions/ImpressionWatcher';
import styled from 'astroturf/react';
import _Container from "TruncateHeight-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TruncateHeight.tsx?styleId=Container";
import _PrefixWithEllipsis from "TruncateHeight-PrefixWithEllipsis.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TruncateHeight.tsx?styleId=PrefixWithEllipsis";
import _SeeMoreContainer from "TruncateHeight-SeeMoreContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/TruncateHeight.tsx?styleId=SeeMoreContainer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const PrefixWithEllipsis = /*#__PURE__*/styled("span", null, {
  displayName: "PrefixWithEllipsis",
  styles: _PrefixWithEllipsis
});

const SeeMoreContainer = /*#__PURE__*/styled(ImpressionWatcher, null, {
  displayName: "SeeMoreContainer",
  styles: _SeeMoreContainer
});

type Props = {
  height?: number;
  collapsible?: boolean;
  verb?: string;
  styledMoreElement?: React.ReactElement;
  readMoreImpressionProps?: ImpressionProps;
};

export const TruncateHeight: React.FC<React.PropsWithChildren<Props>> = ({
  height,
  collapsible = false,
  children,
  verb = 'see',
  styledMoreElement = <div style={{ background: 'white' }} />,
  readMoreImpressionProps = { source: 'read-more', active: false },
}) => {
  height = height || 20 * 6;
  const size = useScreenSize();
  const [canTruncate, setCanTruncate] = useState(false);
  const [truncate, setTruncate] = useState(true);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const showSeeMore = canTruncate && (collapsible || truncate);

  const calculateCanTruncate = (containerDiv: HTMLDivElement) => {
    setCanTruncate(containerDiv.scrollHeight !== containerDiv.offsetHeight);
  };

  useEffect(() => {
    if (container) {
      calculateCanTruncate(container);
    }
  }, [container, size]);

  useResizeObserver(container, (entry) => {
    const target = entry.target as HTMLDivElement;
    calculateCanTruncate(target);
  });

  return (
    <Container
      style={{
        maxHeight: truncate && height !== undefined ? height : undefined,
      }}
      ref={setContainer}
    >
      {children}
      {showSeeMore && (
        <SeeMoreContainer
          onClick={() => setTruncate(!truncate)}
          {...readMoreImpressionProps}
        >
          {React.cloneElement(styledMoreElement, {
            children: (
              <PrefixWithEllipsis>
                {verb}
                &nbsp;
                {truncate ? 'more' : 'less'}
              </PrefixWithEllipsis>
            ),
          })}
        </SeeMoreContainer>
      )}
    </Container>
  );
};
